import { Navigate, Outlet, useLocation } from "react-router-dom"
import { PATHS } from "./routes"
import { createLogger } from "@/utils/logger"
import { Auth } from "@/features_signal/auth"

const logger = createLogger("AuthGuard")

export function AuthGuard() {
    const token = Auth.accessTokenSignal.value
    const location = useLocation()
    const isPublicPath = [PATHS.INDEX, PATHS.LOGIN].includes(location.pathname)

    if (!token && !isPublicPath) {
        return (
            <Navigate
                to={`${PATHS.INDEX}`}
                replace
                state={{
                    from: location.pathname,
                    search: location.search,
                    ignore: true,
                }}
            />
        )
    }

    return <Outlet />
}
